var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"demo"},[_vm._v("lklkl")])
}
var staticRenderFns = []

export { render, staticRenderFns }